export const XBIT_RELAY_DEPOSIT_WALLETS_PERMISSION_RESOURCE =
  'xbit-relay:deposit-wallets';

// Reuse the deposits provider as the default registry filter.
export { DEFAULT_DEPOSITS_PROVIDER as DEFAULT_DEPOSIT_WALLETS_PROVIDER } from '../deposits/constants';
